import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthRoute } from '@/components/AuthRoute';
import Loading from '@/components/Loading';

const Login = lazy(() => import('@/pages/Login'));
const MailLogin = lazy(() => import('@/pages/Login/mailLogin'));
const Home = lazy(() => import('@/pages/Home'));
const Device = lazy(() => import('@/pages/Device'));
const FanNumberConfig = lazy(() => import('@/pages/FanNumberConfig'));
const FanSetting = lazy(() => import('@/pages/FanSetting'));
const FeedSetting = lazy(() => import('@/pages/FeedSetting'));
export default [
  {
    path: '/login',
    element: (
      <Suspense fallback={<Loading />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: '/maillogin',
    element: (
      <Suspense fallback={<Loading />}>
        <MailLogin />
      </Suspense>
    ),
  },
  {
    path: '/',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthRoute>
          <Home />
        </AuthRoute>
      </Suspense>
    ),
  },
  {
    path: '/device/:did',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthRoute>
          <Device />
        </AuthRoute>
      </Suspense>
    ),
  },
  {
    path: '/device/FanNumberConfig/:did',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthRoute>
          <FanNumberConfig />
        </AuthRoute>
      </Suspense>
    ),
  },
  {
    path: '/device/Setting/fan/:did',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthRoute>
          <FanSetting />
        </AuthRoute>
      </Suspense>
    ),
  },
  {
    path: '/device/Setting/feed/:did',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthRoute>
          <FeedSetting />
        </AuthRoute>
      </Suspense>
    ),
  },
  {
    path: '',
    element: <Navigate to='/login' replace />,
  },
];
